export const productCategories = [
    { id: "all", name: "Alle Produkte", translationKey: "all" },
    { id: "blütenhonig", name: "Blütenhonig", translationKey: "flowerHoney" },
    { id: "waldhonig", name: "Waldhonig", translationKey: "forestHoney" },
    { id: "sortenhonig", name: "Sortenhonig", translationKey: "varietyHoney" },
    { id: "bio-honig", name: "Bio-Honig", translationKey: "organicHoney" },
    { id: "propolis", name: "Propolis", translationKey: "propolis" },
    { id: "bienenwachs", name: "Bienenwachs", translationKey: "beeswax" },
    { id: "pollen", name: "Blütenpollen", translationKey: "pollen" },
    { id: "gelee-royale", name: "Gelée Royale", translationKey: "royalJelly" }
];
